export const styles = {
    mainGridWrapper: { minHeight: '375px' },
    skeleton: { marginTop: '50px' },
    firstGridItem: { marginTop: '75px' },
    footerWrapper: { position: 'relative' },
    footerContent: { width: '80px', position: 'absolute', right: '20%', top: '0px' }
}